'use client'

import clsx from 'clsx'
import { useRouter } from 'next/navigation'
import { MouseEvent, useState, useTransition } from 'react'

import { sendYandexMetricaEvent } from '@/shared/integrations/yandex-metric/utils/send-metric-event'
import { Button } from '@/shared/ui'

interface CreateFastOrderProps {
	className?: string
	productId: number
	size?: 'S' | 'M' | 'L'
	fullWidth?: boolean
	KOD: string
	onFastOrder?: () => boolean | Promise<boolean>
	isLoading?: boolean
}

export const CreateFastOrder = (props: CreateFastOrderProps) => {
	const { productId, size = 'M', fullWidth, className, KOD, onFastOrder, isLoading = false } = props

	const router = useRouter()
	const [isSubmitting, setIsSubmitting] = useState(false)
	const [isPending, startTransition] = useTransition()
	const loading = isLoading || isSubmitting || isPending

	const onClick = async (e: MouseEvent<HTMLButtonElement>) => {
		e.preventDefault()
		sendYandexMetricaEvent(`fast_order_click`)
		setIsSubmitting(true)

		try {
			if (onFastOrder && (await onFastOrder())) return
			startTransition(() => router.push(`/order/${productId}?kod=${encodeURIComponent(KOD)}`))
		} finally {
			setIsSubmitting(false)
		}
	}

	return (
		<Button
			theme="clear"
			onClick={onClick}
			size={size}
			fullWidth={fullWidth}
			isLoading={loading}
			disabled={loading}
			className={clsx(className, 'gtm-fast-order')}>
			Быстрый заказ
		</Button>
	)
}
